import api from './api';

/**
 * The agent's own hub data — `/api/v1/posp-hub/` (Messaging Plan 2).
 *
 * Every route is resolved server-side from the logged-in agent; nothing here
 * takes an agent id. XP is points only: no rupee figure of commission is ever
 * returned (IRDAI), and customers have no route to any of it.
 */

export type CoverPreference = 'comprehensive' | 'tp_only' | 'both';

export interface CoverPreferences {
  cover_preference: CoverPreference;
  choices: { value: CoverPreference; label: string }[];
}

export interface XpProjection {
  quote_id: string;
  /** null = "XP pending": no rate card covers this option yet. Never render it as 0. */
  xp: number | null;
  state: 'projected' | 'pending';
  label: string;
}

export const pospHubApi = {
  async getPreferences(): Promise<CoverPreferences> {
    const { data } = await api.get<CoverPreferences>('/posp-hub/preferences/');
    return data;
  },

  async setCoverPreference(value: CoverPreference): Promise<CoverPreferences> {
    const { data } = await api.put<CoverPreferences>('/posp-hub/preferences/', { cover_preference: value });
    return data;
  },

  async getQuoteXp(quoteRequestId: string): Promise<XpProjection[]> {
    const { data } = await api.get<{ options: XpProjection[] }>(
      `/posp-hub/quotes/${encodeURIComponent(quoteRequestId)}/xp/`,
    );
    return data.options;
  },
};
